module.exports = __webpack_public_path__ + "img/02.060dbd76.png";